"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlSpinnerIndeterminateVariant = exports.IlSpinnerDeterminateVariant = exports.IlSpinner = exports.IlSpinnerIndeterminateVariantArgs = exports.IlSpinnerDeterminateVariantArgs = exports.IlSpinnerArgs = void 0;
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_spinner_1 = require("./il-spinner");
exports.IlSpinnerArgs = {};
exports.IlSpinnerDeterminateVariantArgs = {
    variant: enums_1.CircularProgressVariantEnum.DETERMINATE,
};
exports.IlSpinnerIndeterminateVariantArgs = {
    variant: enums_1.CircularProgressVariantEnum.INDETERMINATE,
};
// components
exports.IlSpinner = (0, get_component_1.getComponent)(il_spinner_1.ILSpinner, exports.IlSpinnerArgs);
exports.IlSpinnerDeterminateVariant = (0, get_component_1.getComponent)(il_spinner_1.ILSpinner, exports.IlSpinnerDeterminateVariantArgs);
exports.IlSpinnerIndeterminateVariant = (0, get_component_1.getComponent)(il_spinner_1.ILSpinner, exports.IlSpinnerIndeterminateVariantArgs);
